export default __webpack_public_path__ + "static/media/four.01a39525.jpeg";